import React from 'react';
import '../assets/css/style.css';
import Image1 from '../assets/css/img/main.png'; // Replace with actual paths

import shock from '../assets/css/img/shock.png';

const AboutUs = () => {
  return (
    <section id='About'>
    <div className="container about-us-section mb-5" >
      <div className="row align-items-center">
      <h1 className="green-heading text-center"><img src={shock} className='shock'/>&nbsp;About Us</h1>
        <div className="col-md-6">
          <div className="image-container">
            <img src={Image1} alt="Solar Panel 1" className="img-fluid main-image" />
            {/* <img src={Image2} alt="Solar Panel 2" className="img-fluid sub-image" /> */}
          </div>
        </div>
        <div className="col-md-6 text-section">
          <h2 className="about-titles">Our Ecosolar System to <br></br>Save Energy</h2>
          <p className="about-texts">
          "Axis Solar Systems is dedicated to 
powering a sustainable future with 
clean, reliable solar energy solutions for 
residential, commercial, and industrial 
needs. As an Authorized Channel 
Partner of Tata Power Solar and an 
official MNRE (Ministry of New and 
Renewable Energy) vendor, we follow all 
MNRE policies and standards to ensure 
the highest quality and compliance in 
our installations. Our solutions add 
lasting value to your property, reduce 
energy costs, and contribute to a 
cleaner, greener India. We’re passionate 
about empowering our clients to 
achieve energy independence, 
supporting India’s vision for a carbon-
free future. With a commitment to 
excellence and customer satisfaction, 
Axis Solar Systems is your trusted 
partner in building a sustainable </p>
          </div>
      </div>
    </div>
    </section>
  );
}

export default AboutUs;
